<template>
  <div class="">
    Company Tab
    <div class="">
      <p>Name: {{company.name}}</p>
      <p>Address: {{company.address}}</p>
      <p>City: {{company.city}}</p>
      <p>Country Code: {{company.countryCode}}</p>
      <p>Description {{company.description}}</p>
      <p>Domain {{company.domain}}</p>
      <p>Employee Count {{company.employeeCount}}</p>
      <p>Fax {{company.fax}}</p>
      <p>followerCount {{company.followerCount}}</p>
      <p>Founded {{company.founded}}</p>
      <p>Funding {{company.funding}}</p>
      <p>Industry {{company.industry}}</p>
      <p>Industry Tags {{company.industryTags}}</p>
      <p>LinkedInCompanyId {{company.linkedinCompanyId}}</p>
      <p>Links: {{company.links}}</p>
      <p>Naics Codes {{company.naicsCodes}}</p>
      <p>Phone: {{company.phone}}</p>
      <p>Picture: {{company.picture}}</p>
      <p>Postal Code: {{company.postalCode}}</p>
      <p>Region {{company.region}}</p>
      <p>Revenue {{company.revenue}}</p>
      <p>rocketReachUrl {{company.rocketReachUrl}}</p>
      <p>sic Codes {{company.sicCodes}}</p>
      <p>Similar Websites {{company.similarWebsites}}</p>
      <p>Street {{company.street}}</p>
      <p>Ticker {{company.tickerSymbol}}</p>
      <p>Website {{company.website}}</p>
    </div>
  </div>
</template>
<script>

export default {
    props: {
        company: {
            type: Object,
            required: true
        }
    }
}
</script>
<!--

-->
